<template>
    <div class="corrections-delete">
        <slot>
            <button
                class="button button--blank corrections-delete__button"
                type="button"
                @click="showModal = true"
            >
                <IconBin fill="red" />
            </button>
        </slot>
        <ConfirmModal
            v-if="showModal"
            name="corrections-delete"
            :title="$t('corrections.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deleteCorrection"
            @canceled="showModal = false"
        >
            <template #content>
                <div>
                    <Spinner v-if="loading" />
                    <div class="corrections-delete__content">
                        <p>{{ $t('corrections.delete.content') }}</p>
                    </div>
                    <TransitionExpand v-if="error">
                        <ErrorList :error="error" />
                    </TransitionExpand>
                </div>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import { deleteCorrection } from '../../api/corrections';

export default {
    name: 'CorrectionsDelete',
    components: {
        ConfirmModal,
        TransitionExpand,
        ErrorList,
        IconBin,
    },
    props: {
        correction: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            loading: false,
            error: null,
        };
    },
    methods: {
        async deleteCorrection() {
            try {
                this.loading = true;
                this.error = null;
                await deleteCorrection(this.correction.id);
                await this.$store.dispatch('pushToast', {
                    type: 'success',
                    title: 'Success',
                    text: 'Correction successfully deleted',
                });
                this.showModal = false;
                this.$emit('delete', this.correction.id);
            } catch (e) {
                this.error = e;
                this.$store.dispatch('pushToast', {
                    type: 'error',
                    text: e,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style src="./CorrectionsDelete.scss" lang="scss"></style>
